(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6812],{

/***/ 7086:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/consumer-care/category/[category]/[question]",
      function () {
        return __webpack_require__(4090);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ DidntGetTheAnswerYou; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _styles_components_consumer_care_dont_get_your_answer_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1682);
/* harmony import */ var _styles_components_consumer_care_dont_get_your_answer_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_components_consumer_care_dont_get_your_answer_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_link_silink__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5515);




function DidntGetTheAnswerYou() {
    /**
     * This component is for consumer care contain details and contact us page
     */ return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: (_styles_components_consumer_care_dont_get_your_answer_module_scss__WEBPACK_IMPORTED_MODULE_3___default().didnt_get_the_answer_you),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                children: "didn’t get the answer you were looking for?"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_link_silink__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                classes: "",
                href: "mailto:care@sidr.com",
                children: "contact us"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: "/assets/images/decorations/extra/inner_consumer_care_icon.webp",
                alt: "consumer care"
            })
        ]
    });
}


/***/ }),

/***/ 5515:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _styles_components_link_index_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6886);
/* harmony import */ var _styles_components_link_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_components_link_index_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);




const SILink = (param)=>{
    let { children , onClick =(e)=>{} , ...props } = param;
    const handleOnClick = (e)=>{
        // @ts-ignore
        onClick(e);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
        className: "".concat((_styles_components_link_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().link), " ").concat(props.classes ? props.classes : ""),
        ...props,
        onClick: handleOnClick,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SILink);


/***/ }),

/***/ 231:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ YouMayAlsoLikeHoneyList; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _styles_components_you_may_also_like_honey_list_index_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4391);
/* harmony import */ var _styles_components_you_may_also_like_honey_list_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_components_you_may_also_like_honey_list_index_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);




const YouMayAlsoLikeHoneyList = (param)=>{
    let { title ="" , productType: string = "" , honeyList =[]  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: honeyList && honeyList.length != 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
            className: (_styles_components_you_may_also_like_honey_list_index_module_scss__WEBPACK_IMPORTED_MODULE_3___default().container),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {}),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "product_list",
                    children: honeyList.map((item, index)=>{
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "item item_honey",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                href: "/products/detail/".concat(item.attributes.Collection.data.attributes.Link, "/") + item.attributes.Shopify_Link,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        loading: "lazy",
                                        className: "img_honey",
                                        src: item.attributes.Image.data.attributes.url,
                                        alt: item.attributes.Image.data.attributes.alternativeText
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "bar_line bar_line_honey"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        children: item.attributes.Title
                                    })
                                ]
                            })
                        }, "product-" + index);
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {})
            ]
        })
    });
};


/***/ }),

/***/ 4090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _styles_pages_consumer_care_category_question_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6065);
/* harmony import */ var _styles_pages_consumer_care_category_question_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_pages_consumer_care_category_question_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _components_link_silink__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5515);
/* harmony import */ var _components_consumer_care_dont_get_your_answer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4681);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _components_you_may_also_like_honey_list__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(231);







// @ts-ignore
function ConsumerCareCategoryQuestionAnswer(param) {
    let { FAQ , faqStructuredData , relatedProducts  } = param;
    /**
     * Contain footer component
     * view all faq button user can see all category, and print topic can print current page
     * if not found any related then they can contact us
     */ return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_4___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(faqStructuredData)
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: (_styles_pages_consumer_care_category_question_module_scss__WEBPACK_IMPORTED_MODULE_6___default().question_answer),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        children: FAQ.Question
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        children: [
                            "Views: ",
                            FAQ.Views ? FAQ.Views : 0
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "answer",
                        dangerouslySetInnerHTML: {
                            __html: FAQ.Answer
                        }
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "other_links",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_link_silink__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                classes: "print_topic",
                                href: "#!",
                                onClick: ()=>{
                                    window.print();
                                },
                                children: "print topic"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_link_silink__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                classes: "view_all_faq",
                                href: "/consumer-care-all-faq",
                                children: [
                                    "view all faq",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: "s"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("hr", {
                className: (_styles_pages_consumer_care_category_question_module_scss__WEBPACK_IMPORTED_MODULE_6___default().hr)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_you_may_also_like_honey_list__WEBPACK_IMPORTED_MODULE_5__/* .YouMayAlsoLikeHoneyList */ .b, {
                title: "you may also try",
                honeyList: relatedProducts
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_consumer_care_dont_get_your_answer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {})
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (ConsumerCareCategoryQuestionAnswer);


/***/ }),

/***/ 1682:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#1d1f22","secondary":"#ece8e1","title-secondary":"#575759","body":"#f4f3f0","text-color-white":"#f9f7f2","red":"#cd5f5f","golden":"#c2ab7a","gray":"#938985","didnt_get_the_answer_you":"dont-get-your-answer_didnt_get_the_answer_you__3TwOy","about-image-in":"dont-get-your-answer_about-image-in__3xF_o","fade-in-honeycomb":"dont-get-your-answer_fade-in-honeycomb__z8IEM","dot-falling":"dont-get-your-answer_dot-falling__edfhj","dot-falling-before":"dont-get-your-answer_dot-falling-before__6mTNK","dot-falling-after":"dont-get-your-answer_dot-falling-after__U81tU"};

/***/ }),

/***/ 6886:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#1d1f22","secondary":"#ece8e1","title-secondary":"#575759","body":"#f4f3f0","text-color-white":"#f9f7f2","red":"#cd5f5f","golden":"#c2ab7a","gray":"#938985","link":"link_link__T8hPh","about-image-in":"link_about-image-in__JsJpN","fade-in-honeycomb":"link_fade-in-honeycomb__iJ7y6","dot-falling":"link_dot-falling__xjMoT","dot-falling-before":"link_dot-falling-before__Qz2nK","dot-falling-after":"link_dot-falling-after__fHF3N"};

/***/ }),

/***/ 4391:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#1d1f22","secondary":"#ece8e1","title-secondary":"#575759","body":"#f4f3f0","text-color-white":"#f9f7f2","red":"#cd5f5f","golden":"#c2ab7a","gray":"#938985","container":"you-may-also-like-honey-list_container__9lqdX","about-image-in":"you-may-also-like-honey-list_about-image-in__5uTWH","fade-in-honeycomb":"you-may-also-like-honey-list_fade-in-honeycomb__Jx4_6","dot-falling":"you-may-also-like-honey-list_dot-falling__QFRqg","dot-falling-before":"you-may-also-like-honey-list_dot-falling-before__h6oE7","dot-falling-after":"you-may-also-like-honey-list_dot-falling-after__eoGWd"};

/***/ }),

/***/ 6065:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primary":"#1d1f22","secondary":"#ece8e1","title-secondary":"#575759","body":"#f4f3f0","text-color-white":"#f9f7f2","red":"#cd5f5f","golden":"#c2ab7a","gray":"#938985","question_answer":"category-question_question_answer__yoGf6","hr":"category-question_hr__oJSsa","about-image-in":"category-question_about-image-in__gF82_","fade-in-honeycomb":"category-question_fade-in-honeycomb__lrl78","dot-falling":"category-question_dot-falling__emhSg","dot-falling-before":"category-question_dot-falling-before__KP5e0","dot-falling-after":"category-question_dot-falling-after__eeeI8"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(7086); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);